import script from "./CalendarPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarPage.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarPage.vue?vue&type=style&index=0&id=e6b44978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6b44978"]])

export default __exports__